/* In-cart special scene module. SHFTDTakeoverScene.mount(root) initializes once per root (idempotent); cart-drawer.js calls it when the intercept opens. Ported from design/intercept-prototypes/merge-number-hero.html. */

window.SHFTDTakeoverScene = { mount: function(root, opts){
  "use strict";
  if (root.dataset.tkscMounted) return; root.dataset.tkscMounted = '1';
  var cv=root.querySelector('[data-tk="gl"]'), fb=root.querySelector('[data-tk="fb"]'),
      tilt=root.querySelector('[data-tk="tilt"]'), tk=root.querySelector('[data-tk="tk"]'),
      sheen=root.querySelector('[data-tk="sheen"]'), lit=root.querySelector('[data-tk="lit"]'),
      tksh=root.querySelector('[data-tk="tksh"]'), tkrf=root.querySelector('[data-tk="tkrf"]'),
      stage=cv.parentElement;
  var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- WebGL headlight (single light source of the whole scene) ---------- */
  var gl=null, glOK=false, uR=null, uT=null;
  try{
    gl=cv.getContext('webgl',{antialias:false,alpha:false,powerPreference:'high-performance'})
      ||cv.getContext('experimental-webgl');
  }catch(e){gl=null;}
  function glFail(){cv.hidden=true;fb.hidden=false;glOK=false;}
  if(gl){
    var VS='attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
    var FS=[
    'precision highp float;',
    'uniform vec2 R;uniform float T;',
    'float h21(vec2 p){p=fract(p*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}',
    'float vn(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);',
    ' float a=h21(i),b=h21(i+vec2(1.,0.)),c=h21(i+vec2(0.,1.)),d=h21(i+vec2(1.,1.));',
    ' return mix(mix(a,b,f.x),mix(c,d,f.x),f.y);}',
    'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<3;i++){v+=a*vn(p);p=p*2.03+7.7;a*=.5;}return v;}',
    'float dust(vec2 uv,float t,float sc,float sp,float sd){',
    ' vec2 p=uv*sc;p.y+=t*sp;p.x+=sin(t*.3+sd)*.3;',
    ' vec2 id=floor(p),f=fract(p);float r=h21(id+sd);',
    ' vec2 c=vec2(.2+.6*fract(r*7.31),.2+.6*fract(r*4.17));',
    ' c+=.12*vec2(sin(t*(.6+r)+r*40.),cos(t*(.8+r)+r*20.));',
    ' float d=length(f-c);float tw=.4+.6*(.5+.5*sin(t*(1.5+2.*r)+r*30.));',
    ' return smoothstep(.09,.01,d)*tw*step(.45,r);}',
    'void main(){',
    ' vec2 uv=(gl_FragCoord.xy-.5*R)/R.y;float t=T;',
    /* stuttered ignition, then locked on (mirrored in JS for the DOM objects) */
    ' float ig=smoothstep(0.,.08,t)*mix(.15+.85*step(.6,h21(vec2(floor(t*26.),3.))),1.,smoothstep(.35,.95,t));',
    ' vec3 col=mix(vec3(.012,.012,.016),vec3(.035,.032,.042),clamp(uv.y+.5,0.,1.));',
    /* volumetric beam from top center: cone * falloff * breathing haze */
    ' vec2 d=uv-vec2(0.,.66);',
    ' float sw=sin(t*.42)*.05;float ca=cos(sw),sa=sin(sw);',
    ' d=vec2(ca*d.x-sa*d.y,sa*d.x+ca*d.y);',
    ' float cone=smoothstep(.62,.12,abs(atan(d.x,-d.y)));',
    ' float fall=exp(-length(d)*1.35);',
    ' float haze=.55+.45*fbm(uv*2.6+vec2(t*.05,-t*.12));',
    ' float br=.86+.14*sin(t*1.05);',
    ' float beam=cone*fall*haze*br*ig;',
    ' vec3 warm=vec3(1.,.93,.78);',
    ' col+=warm*beam*.8;',
    /* glossy floor: hot pool + narrow reflection streak; horizon sits at the number's contact line */
    ' float fy=-.05;float fm=smoothstep(fy+.015,fy-.02,uv.y);float dn=max(fy-uv.y,0.);',
    ' col+=fm*warm*exp(-pow(uv.x*2.4,2.))*exp(-dn*4.5)*.42*ig*br;',
    ' col+=warm*exp(-pow(uv.x*8.,2.))*exp(-dn*3.)*fm*.22*ig;',
    /* red horizon + ambient spill + corner rims (brand accent) */
    ' vec3 red=vec3(.9,.17,0.);',
    /* soft glow band instead of a hard laser line (owner note: the sharp
       horizon read as a weird cutoff) */
    ' col+=red*exp(-pow((uv.y-fy)*26.,2.))*(.16+.05*sin(t*.9))*ig;',
    ' col+=red*exp(-abs(uv.y-fy)*10.)*.07*ig;',
    ' col+=red*smoothstep(.34,.7,abs(uv.x))*smoothstep(.15,-.55,uv.y)*.14*ig;',
    /* gold dust only inside the beam */
    ' float pd=dust(uv,t,9.,.05,1.7)+dust(uv,t,16.,.09,4.2)*.7;',
    ' col+=vec3(1.,.84,.47)*pd*beam*1.6;',
    ' col*=smoothstep(1.38,.3,length(uv*vec2(.82,.95)));',
    ' col+=(h21(gl_FragCoord.xy+fract(t)*7.)-.5)*.011;',
    ' col=pow(max(col,0.),vec3(.85));',
    ' gl_FragColor=vec4(col,1.);}'
    ].join('\n');
    var mk=function(type,src){
      var s=gl.createShader(type);
      gl.shaderSource(s,src);gl.compileShader(s);
      if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))return null;
      return s;
    };
    var vs=mk(gl.VERTEX_SHADER,VS),fs=mk(gl.FRAGMENT_SHADER,FS);
    if(vs&&fs){
      var pr=gl.createProgram();
      gl.attachShader(pr,vs);gl.attachShader(pr,fs);gl.linkProgram(pr);
      if(gl.getProgramParameter(pr,gl.LINK_STATUS)){
        gl.useProgram(pr);
        var buf=gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER,buf);
        gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,3,-1,-1,3]),gl.STATIC_DRAW);
        var loc=gl.getAttribLocation(pr,'p');
        gl.enableVertexAttribArray(loc);
        gl.vertexAttribPointer(loc,2,gl.FLOAT,false,0,0);
        uR=gl.getUniformLocation(pr,'R');uT=gl.getUniformLocation(pr,'T');
        glOK=true;
      }
    }
  }
  if(!glOK) glFail();

  function fit(){
    if(!glOK)return;
    var dpr=Math.min(window.devicePixelRatio||1,2);
    var w=stage.clientWidth,h=stage.clientHeight;
    if(cv.width!==w*dpr||cv.height!==h*dpr){
      cv.width=w*dpr;cv.height=h*dpr;
      gl.viewport(0,0,cv.width,cv.height);
    }
    gl.uniform2f(uR,cv.width,cv.height);
  }
  function draw(t){
    if(!glOK)return;
    gl.uniform1f(uT,t);
    gl.drawArrays(gl.TRIANGLES,0,3);
  }

  /* ---------- JS mirrors of the shader light math (light-source consistency) ---------- */
  function fr(v){return v-Math.floor(v);}
  function h21(x,y){
    x=fr(x*123.34);y=fr(y*456.21);
    var d=x*(x+45.32)+y*(y+45.32);
    x=fr(x+d);y=fr(y+d);
    return fr(x*y);
  }
  function ss(a,b,x){var u=Math.min(Math.max((x-a)/(b-a),0),1);return u*u*(3-2*u);}
  function igOf(t){ /* same stuttered flick-on the beam uses */
    var m=ss(.35,.95,t);
    var fl=.15+.85*(h21(Math.floor(t*26),3)>=.6?1:0);
    return ss(0,.08,t)*(fl*(1-m)+m);
  }

  /* ---------- DOM pose update: ticket hung in the beam, all on the beam's clock ---------- */
  function pose(t){
    var ig=igOf(t);
    var sw=Math.sin(t*.42)*.05;            /* beam sway, radians (identical to shader) */
    var br=.86+.14*Math.sin(t*1.05);       /* beam breath */
    var intro=Math.min(t/1.2,1), ei=1-Math.pow(1-intro,3);

    /* the lit objects flick on WITH the lamp, then pulse with its breath */
    lit.style.opacity=(ig*(.86+.14*br)).toFixed(3);

    /* ticket: slow drift + pendulum lean following the beam sway */
    var rx=17+Math.sin(t*.6)*3+Math.sin(t*.233+2)*1.4;
    var ry=-15+Math.sin(t*.43+1)*5+Math.sin(t*.191)*2;
    var rz=-5+sw*80;
    var fy=Math.sin(t*.52)*4;
    tk.style.transform=
      'translate3d(0,'+(fy-(1-ei)*-34).toFixed(2)+'px,0)'+
      ' rotateX('+rx.toFixed(2)+'deg) rotateY('+ry.toFixed(2)+'deg) rotateZ('+rz.toFixed(2)+'deg)';

    /* specular band: position = overhead light direction (sway) + ticket yaw */
    var sx=150+sw*1400+ry*5-(1-ei)*330;
    sheen.style.transform='translateX('+sx.toFixed(1)+'px) rotate('+(10+sw*60).toFixed(1)+'deg)';
    sheen.style.opacity=(.45+Math.abs(sw)*7+Math.min(Math.abs(ry+15)/14,.2)).toFixed(2);

    /* floor contact: shadow slides OPPOSITE the sway (light pivots overhead), breathes with float */
    var shx=-sw*260;
    tksh.style.transform='translateX('+shx.toFixed(1)+'px) scaleX('+(1+Math.abs(sw)*3+fy*.004).toFixed(3)+')';
    tksh.style.opacity=(.26*ig*(1-fy*.02)).toFixed(3);
    tkrf.style.transform='translateX('+(sw*90).toFixed(1)+'px) scaleY(-.5)';
    tkrf.style.opacity=(.09*ig*br).toFixed(3);

    /* hero number leans with the same sway: one scene, one light */
    tilt.style.transform='perspective(700px) rotateX('+(8+2.2*Math.sin(t*.55)).toFixed(2)+
      'deg) rotateY('+(sw*70).toFixed(2)+'deg)';
  }

  fit();
  window.addEventListener('resize',function(){
    fit();
    if(RM) draw(8.0);
  });

  if(RM){
    /* one designed, fully-lit static frame; CSS poses stand as-is */
    draw(8.0);
    lit.style.opacity=1;
    return;
  }

  /* single rAF: shader + every DOM light response share one accumulated clock */
  var acc=0,last=null,raf=0;
  function frame(now){
    if(!root.isConnected){cancelAnimationFrame(raf);return;}
    /* Idle cheaply while the takeover is hidden; resume drawing on show. */
    if(root.offsetParent===null){last=null;raf=requestAnimationFrame(frame);return;}
    /* Mounted-while-hidden leaves a 0x0 canvas; refit when the visible
       size disagrees with the framebuffer. */
    if(cv&&stage&&cv.width!==Math.round(stage.clientWidth*Math.min(window.devicePixelRatio||1,2))){try{fit();}catch(_){ }}
    if(last===null)last=now;
    acc+=Math.min(now-last,50);last=now;
    var t=acc/1000;
    draw(t);
    pose(t);
    raf=requestAnimationFrame(frame);
  }
  raf=requestAnimationFrame(frame);

  document.addEventListener('visibilitychange',function(){
    if(document.hidden){cancelAnimationFrame(raf);last=null;}
    else{raf=requestAnimationFrame(frame);}
  });

} };